import { Component } from '@angular/core';
import { GridService } from '../../grid.service';
import Article from '@app/edit/article';
import * as moment from 'moment';

@Component({
  selector: 'app-content-panel-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.less']
})
export class SettingsComponent {
  constructor(
    public gridService: GridService,
  ) { }

  datePresentation(date) {
    return moment().to(date);
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/settings/settings.component.ts